var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content account" },
    [
      _vm.isLoggedIn
        ? _c("div", { staticClass: "deposit-threshold ctsform" }, [
            !_vm.accountSummaryFlow
              ? _c("h1", [_vm._v(_vm._s(_vm.$t("Account.DepositThreshold")))])
              : _vm._e(),
            _vm._v(" "),
            _vm.lifetimeDepositReached
              ? _c(
                  "div",
                  { staticClass: "dep-treshold-container deposit-reached" },
                  [
                    _c("p", { staticClass: "dep-reach-info" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("Account.DepositThreshold.Info", {
                              currency: _vm.currencySymbol
                            })
                          )
                        )
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("Account.DepositThreshold.Info.Details", {
                              currency: _vm.currencySymbol
                            })
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "save-button-container form-actions" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "transactions",
                            attrs: { color: "success", "x-large": "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.acknowledgeSuspension()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.DepositThreshold.Confirmation"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.lifetimeDepositReached
              ? _c("div", { staticClass: "dep-treshold-container no-action" }, [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("Account.DepositThreshold.NoAction.Info", {
                          currency: _vm.currencySymbol
                        })
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("Account.DepositThreshold.NoAction", {
                          currency: _vm.currencySymbol
                        })
                      )
                    }
                  })
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ProcessingDialog",
        {
          attrs: {
            isDialogPersistent: true,
            isProcessing: _vm.isProcessing,
            isSuccess: !_vm.transactionError,
            processingTitle: _vm.$t(
              "Account.PersonalDetails.Dialog.Processing.Title"
            ),
            processingText: _vm.$t(
              "Account.PersonalDetails.Dialog.Processing.Text"
            ),
            successTitle: _vm.$t("Account.CloseAccount.Dialog.Success.Title"),
            successText: _vm.$t("ProcessingDialog.Success.Text"),
            errorTitle: _vm.$t("ProcessingDialog.Error.Title"),
            closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
            _vm.brandKey !== "sb"
              ? _c(
                  "p",
                  { staticClass: "generic-icon-note" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-1", attrs: { color: "error" } },
                      [_vm._v("error")]
                    ),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Account.Join.Dialog.Error.Text")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "response-error" }, [
              _vm._v(_vm._s(_vm.transactionError))
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "Account.PersonalDetails.Dialog.Error.Text.ContactSupport"
                  )
                )
              }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8e1c0a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8e1c0a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/DepositThresholdComponent.vue
// module id = null
// module chunks = 